import { useEvent } from './use-event';
export function useOutsideClick(target, callback) {
    useEvent('click', (e) => {
        if (target.current && !target.current.contains(e.target)) {
            callback();
        }
    });
}
